import styles from "../../components/Dialogs/DialogMessageInput/DialogMessageInput.module.scss"

export const scrollDownMessageInput = () => {
    const messageInput = document.querySelector(`.${styles.messageInput__control}`)

    if (messageInput) {
        messageInput.scrollTop = messageInput.scrollHeight
    }
}
